import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const { signInWithGoogle, error, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-bone flex items-center justify-center">
        <div className="text-navy text-[14px]">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center">
      <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-10 w-[400px] text-center">
        {/* Logo / Brand */}
        <div className="mb-8">
          <h1 className="text-[24px] font-bold text-navy tracking-wide">
            Bullogic Command Center
          </h1>
          <p className="text-[13px] text-[#888] mt-2">
            Financial Intelligence Dashboard
          </p>
        </div>

        {/* Error message */}
        {error && (
          <div className="bg-rose/10 border border-rose/30 rounded-[4px] px-4 py-3 mb-6">
            <p className="text-[12px] text-rose font-bold">{error}</p>
          </div>
        )}

        {/* Sign in button */}
        <button
          onClick={signInWithGoogle}
          className="w-full flex items-center justify-center gap-3 px-6 py-3 bg-white border-2 border-gray-200 rounded-[4px] hover:bg-gray-50 hover:border-gray-300 transition-colors"
        >
          <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" fill="#34A853"/>
            <path d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
          </svg>
          <span className="text-[14px] font-bold text-near-black">
            Sign in with Google
          </span>
        </button>

        <p className="text-[11px] text-[#aaa] mt-6">
          Restricted to authorized Bullogic employees only.
        </p>
      </div>
    </div>
  );
}
